<template>
  <section class="labor-services section" :key="tabsKey">
    <div class="content">
      <div class="tab-panel" v-if="activeTab === 'labor'">
        <div class="panel-head">
          <div class="panel-kicker">{{ panels.labor.kicker }}</div>
          <div class="panel-title">{{ panels.labor.title }}</div>
        </div>
        <div class="service-grid">
          <div class="service-card" v-for="item in localizedLaborServices" :key="item.title" :class="item.reverse ? 'reverse' : ''">
            <img class="img" :src="item.image" :alt="item.title" />
            <div class="contentWrapper">
              <div class="title">{{ item.title }}</div>
              <div class="border"></div>
              <div class="content">{{ item.content }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="tab-panel" v-else-if="activeTab === 'talent'">
        <div class="panel-head">
          <div class="panel-kicker">{{ panels.talent.kicker }}</div>
          <div class="panel-title">{{ panels.talent.title }}</div>
        </div>
        <div class="service-grid">
          <div class="service-card" v-for="(item, index) in localizedTalentServices" :key="item.title" :class="index % 2 === 0 ? 'reverse' : ''">
            <img class="img" :src="item.image" :alt="item.title" />
            <div class="contentWrapper">
              <div class="title">{{ item.title }}</div>
              <div class="border"></div>
              <div class="content">{{ item.content }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="tab-panel" v-else-if="activeTab === 'manage'">
        <div class="panel-head">
          <div class="panel-kicker">{{ panels.manage.kicker }}</div>
          <div class="panel-title">{{ panels.manage.title }}</div>
        </div>
        <div class="service-grid manage-grid">
          <div class="service-card" v-for="(item, index) in localizedManageServices" :key="item.title" :class="index % 2 === 1 ? 'reverse' : ''">
            <div class="anchor" :id="item.anchor"></div>
            <img class="img" :src="item.image" :alt="item.title" />
            <div class="contentWrapper">
              <div class="title">{{ item.title }}</div>
              <div class="border"></div>
              <div class="content">{{ item.content }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'LaborServiceTabs',
  props: {
    activeTab: { type: String, required: true },
    laborServices: { type: Array, required: true },
    talentServices: { type: Array, required: true },
    manageServices: { type: Array, required: true }
  },
  computed: {
    tabsKey() {
      return (this.$i18n && this.$i18n.locale) || 'zh-CN'
    },
    panels() {
      console.log('[LaborServiceTabs panels]', {
        locale: this.$i18n && this.$i18n.locale,
        laborTitle: this.$t('laborRelations.tabs.laborTitle')
      })
      return {
        labor: {
          kicker: this.$t('laborRelations.tabs.labor'),
          title: this.$t('laborRelations.tabs.laborTitle')
        },
        talent: {
          kicker: this.$t('laborRelations.tabs.talent'),
          title: this.$t('laborRelations.tabs.talentTitle')
        },
        manage: {
          kicker: this.$t('laborRelations.tabs.manage'),
          title: this.$t('laborRelations.tabs.manageTitle')
        }
      }
    },
    localizedLaborServices() {
      return this.laborServices.map(item => ({
        ...item,
        title: this.$t(item.titleKey),
        content: this.$t(item.contentKey)
      }))
    },
    localizedTalentServices() {
      return this.talentServices.map(item => ({
        ...item,
        title: this.$t(item.titleKey),
        content: this.$t(item.contentKey)
      }))
    },
    localizedManageServices() {
      return this.manageServices.map(item => ({
        ...item,
        title: this.$t(item.titleKey),
        content: this.$t(item.contentKey)
      }))
    }
  }
}
</script>

<style scoped>
.section { width: 1200px; margin: 0 auto; }
.content { padding: 72px 0 40px; }
.tab-panel { padding: 36px 0 8px; }
.panel-head { text-align: center; margin-bottom: 28px; }
.panel-kicker { color: #1c51a3; font-size: 14px; letter-spacing: .12em; text-transform: uppercase; }
.panel-title { margin-top: 8px; font-size: 34px; font-weight: 700; color: #111; }
.service-grid { display: grid; gap: 28px; }
.service-card { display: flex; align-items: center; gap: 44px; padding-bottom: 28px; border-bottom: 1px solid #f0f0f0; }
.manage-grid .service-card { padding: 42px 0 56px; border-bottom: 1px solid #e9e9e9; }
.service-card.reverse { flex-direction: row-reverse; }
.manage-grid .service-card .img { width: 58%; }
.manage-grid .service-card .contentWrapper { width: 42%; }
.anchor { position: absolute; top: -110px; left: 0; width: 1px; height: 1px; visibility: hidden; }
.service-card .img { width: 44%; }
.service-card .contentWrapper { width: 56%; }
.title { font-size: 28px; font-weight: 700; color: #111; margin-top: 16px; }
.border { width: 62px; height: 3px; background: #1c51a3; margin: 12px 0; }
.content { color: #444; line-height: 1.9; font-size: 16px; text-align: left; }
</style>
